export const NOT_STARTED = "NOT_STARTED";
export const STARTED = "STARTED";
export const CLOSED = "CLOSED";
export const COMPLETE = "COMPLETE";
